import Carousel from '/components/Carousel';
import Clickable from '/components/Clickable';
import Image from '/components/Image';
import PropTypes from 'prop-types';
import Typography from '/components/Typography';
import classNames from '/utils/class-names';
import { useEffect, useRef, useState } from 'react';

const ActiveProduct = ({
	activeGroupIndex,
	addToPack,
	builderConfig,
	packConfig,
	product,
	showAddedMessaging,
}) => {
	const [hideButton, setHideButton] = useState(false);
	const sliderRef = useRef();

	useEffect(() => {
		if (
			builderConfig?.productCountMax &&
			packConfig?.selectedProducts?.length >= builderConfig.productCountMax
		) {
			setHideButton(true);
			return;
		}

		setHideButton(false);
	}, [builderConfig, packConfig]);

	useEffect(() => {
		sliderRef.current?.slickGoTo(0);
	}, [product?.handle]);

	if (!product?.shopifyProductId) {
		return null;
	}
	const currentStyle = packConfig.productConfigs[activeGroupIndex];

	return (
		<div className="w-full max-w-[85vw] relative">
			<Typography variant="subtitle-md" className="capitalize text-v2-brown-darker mb-4">
				{product?.title?.split(' | ')[0]} {currentStyle?.productType?.name}
			</Typography>

			{product?.images && (
				<div className="w-full md:mb-10">
					<Carousel dots ref={sliderRef}>
						{product?.images.map((image, i) => {
							return (
								<figure key={i}>
									<Image
										alt={image.altText || product.title}
										blurPreload={true}
										height={500}
										objectFit="contain"
										src={image.imageSrc}
										width={500}
									/>
								</figure>
							);
						})}
					</Carousel>
				</div>
			)}

			{(!product?.images || product.images.length === 0) && <div className="h-[500px]" />}

			<div className="absolute bottom-0 left-0 right-0 p-4">
				<div className="relative">
					<div className="relative">
						{!hideButton && (
							<Clickable
								onClick={() => addToPack(product)}
								variant="round-filled"
								className={classNames(
									'rounded-full text-v2-off-white w-42',
									showAddedMessaging ? '!bg-green-600' : '!bg-v2-primary',
								)}>
								{showAddedMessaging ? 'Adding' : 'Add To Pack'}
							</Clickable>
						)}
					</div>
				</div>
			</div>
		</div>
	);
};

ActiveProduct.propTypes = {
	activeGroupIndex: PropTypes.number,
	addToPack: PropTypes.func,
	builderConfig: PropTypes.object,
	packConfig: PropTypes.object,
	product: PropTypes.object,
	showAddedMessaging: PropTypes.bool,
};

export default ActiveProduct;
